import React, { useContext } from 'react';
import { WindowSizeContext } from '/src/App';
import './style.css';

const FinancialImpactBar = ({ impactData, barValue, index }) => {
    const { deviceType } = useContext(WindowSizeContext);
    // Determine color based on value (0-10 scale)
    const getBarColor = (value) => {
        if (value >= 7) return 'var(--related_red, #ff4444)';
        if (value >= 4) return 'var(--yellow, #ff9933)';
        return 'var(--green, #4CAF50)';
    };

    const getBarColorCSS = (value) => {
        if (value >= 7) return 'high';
        if (value >= 4) return 'medium';
        return 'low';
    };

    // Calculate percentage height (max value is 10)
    const heightPercentage = (barValue / 10) * 100;

    let homepageTimeframeText = impactData.homepageTimeframe;
    if (deviceType === 'mobile') {
        homepageTimeframeText = impactData.homepageTimeframeShort;
    }

    return (
        <div className={`financial-impact-bar-container ${deviceType}`}>
            {/* Connection point for React Flow */}
            <div
                id={`impact-bar-target-${index}`}
                className="impact-bar-connection-point"
            />

            {/* Bar Chart */}
            <div className={`impact-bar-chart-wrapper ${deviceType}`}>
                <div className={`impact-bar-chart ${deviceType}`}>
                    <div
                        className={`impact-bar-fill ${getBarColorCSS(barValue)}`}
                        style={{
                            height: `${heightPercentage}%`,
                            // backgroundColor: getBarColor(barValue)
                        }}
                    />
                </div>
            </div>

            {/* Content */}
            <div className={`impact-bar-content ${deviceType}`}>
                <div className={`impact-bar-badge ${deviceType}`}>
                    {homepageTimeframeText}
                </div>
                {/* <h3 className="impact-bar-title">
                    {impactData.title}
                </h3> */}
                {/* <span className="impact-bar-description">
                    {impactData.question}
                </span> */}
            </div>
        </div>
    );
};

export default FinancialImpactBar;
